import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from 'yup';

export interface IContactFormMeta {
  firstName: FormInputMeta,
  lastName: FormInputMeta,
  position: FormInputMeta,
  phone: FormInputMeta,
  email: FormInputMeta,
}

const ContactFormMeta: IContactFormMeta = {} as IContactFormMeta;

ContactFormMeta.firstName = {
  name: 'firstName',
  type: 'text',
  label: 'Prénom',
  placeholder: 'Prénom',
  validation: yup.string().required(),
};

ContactFormMeta.lastName = {
  name: 'lastName',
  type: 'text',
  label: 'Nom',
  placeholder: 'Nom',
  validation: yup.string().required(),
};

ContactFormMeta.position = {
  name: 'position',
  type: 'text',
  label: 'Fonction',
  placeholder: 'Fonction',
  validation: yup.string().required(),
};

ContactFormMeta.phone = {
  name: 'phone',
  type: 'text',
  label: 'Tél',
  placeholder: 'Tél',
  validation: yup.string().required(),
};

ContactFormMeta.email = {
  name: 'email',
  type: 'text',
  label: 'Email',
  placeholder: 'Email',
  validation: yup.string().required(),
};

export default ContactFormMeta;